import firebase from 'firebase/app';
import 'firebase/firestore';
import initFireBase from './initFirebase.js';
initFireBase();
const firestore = firebase.firestore();
export const saveToFirebase = async (highscore) => {
    const { collectionName, username, time, score } = highscore;
    const res = await firestore.collection(collectionName).add({
        time,
        username,
        score: score !== null && score !== void 0 ? score : 0,
    });
    return res;
};
export function getScore(collection) {
    return firestore
        .collection(collection)
        .orderBy('score', 'desc')
        .orderBy('time', 'asc')
        .limit(3)
        .get()
        .then((querySnapshot) => {
        const temp = [];
        querySnapshot.forEach((doc) => {
            const { username, time, score } = doc.data();
            const highscore = {
                collectionName: collection,
                username,
                score,
                time,
            };
            temp.push(highscore);
        });
        return temp;
    });
}
